module.exports = __webpack_public_path__ + "static/media/Bulk Upload Price Dealshub B2B.2626b1cb.xlsx";